import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installDomTranslationGuard } from "./lib/domTranslationGuard";

installDomTranslationGuard();

createRoot(document.getElementById("root")!).render(<App />);
